<template>
    <div class="home">
        <header-small></header-small>
        <div>
            <app-details />
        </div>
        <div style="background-color: #efefef">
            <b-container class="pb-3">
                <b-row>
                    <b-col>
                        <h2>Preis</h2>
                        <div class="line-wrapper"><span class="line"></span></div>
                        <b-list-group>
                            <b-list-group-item class="flex-column align-items-start">
                                <div class="d-flex w-100">
                                    <h5 class="mb-1">ab 60 € für 2 Personen pro Übernachtung</h5>
                                </div>
                                <div>
                                    <p>
                                        Für jede weitere Person +5 € / Übernachtung
                                    </p>
                                    <p>
                                        Bei Stornierung bis 14 Tage vor Antritt sind 80% der Gesamtmiete zu entrichten,<br />
                                        sofern es dem Vermieter nicht gelingt, das Ferienhaus anderweitig zu vermieten.
                                    </p>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Parallax from 'vue-parallaxy'
import AppDetails from '@/components/Details'
import Navigation from '@/components/Navigation'
import HeaderSmall from '@/components/HeaderSmall'

export default {
  name: 'home',
  metaInfo: {
    title: 'Ferienhaus Weber',
    htmlAttrs: {
      lang: 'de'
    },
    meta: [
      { name: 'description', content: 'Unser Ferienhaus liegt zentral zwischen dem Nationalpark Sächsische Schweiz und der Landeshauptstadt Dresden. Sie können Ihren Urlaub abwechslungsreich gestalten. Sie können Wandern, Klettern, Radfahren, oder Museen, Burgen und Städte besichtigen.' },
      { name: 'keywords', content: 'Sächsische Schweiz, Pirna, Dresden, Wanderung, Ländlich, Bergsteigen, Paddeln, Active Urlaub' }
    ]
  },
  components: {
    HeaderSmall,
    Navigation,
    Parallax,
    AppDetails
  }
}
</script>
